// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ring-docked-panel{margin-top:32px;padding-left:0;border-top:none}.ring-docked-panel_fixed.ring-docked-panel_fixed{position:fixed;top:auto;right:0;left:0;bottom:0;padding-left:32px;padding-top:12px;padding-bottom:12px;z-index:2;width:100%;margin-left:0;background-color:#fff;background-color:var(--ring-content-background-color);border-top:1px solid rgba(0, 42, 76, 0.1);border-top:1px solid var(--ring-popup-border-color)}", ""]);
// Exports
module.exports = exports;
